module.exports = __webpack_public_path__ + "static/media/Credibility_ICON.f2e97299.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/drivers/Credibility_ICON.svg
// module id = 1607
// module chunks = 0